<template>
  <div>
    <ca-heading text="Pagamento de Autônomo" />

    <ca-page>
      <ca-form
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Período">
              <ca-monthpicker v-model="selectedDate"></ca-monthpicker>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Número inicial de recibos">
              <ca-input v-model="initialReceiptNumber" type="number"></ca-input>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button>
                Gerar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import moment from 'moment';
import { getBoxInformationErrorMessage } from 'packages/common/utils';
import { getFormattedPeriod } from 'packages/common/utils/format';
import { openPdf } from 'packages/common/utils/file';
import { getRpa } from './paymentService';

export default {
  name: 'RpaFormPage',
  data() {
    return {
      initialReceiptNumber: 0,
      selectedDate: moment().format('DD/MM/YYYY'),
      errorMessage: null,
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'PaymentPage' });
    },
    onSubmit() {
      const params = {
        type: 'SELF_EMPLOYED_PAYMENT_RECEIPT',
        format: 'PDF',
        competence: getFormattedPeriod(this.selectedDate),
        receiptStartNumber: this.initialReceiptNumber,
      };

      return getRpa(params).then(openPdf);
    },
    onSubmitSuccess() {
      this.$router.push({ name: 'PaymentPage' });
      this.$toaster.success('RPA gerado com sucesso!');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
  },
};
</script>
